import React from 'react';
import useEditorStore from '../store/useEditorStore';
import { Ruler, ZoomIn } from 'lucide-react';

export default function ScaleIndicator() {
  const dimensions = useEditorStore((s) => s.dimensions);
  const segments = useEditorStore((s) => s.segments);
  const viewScale = useEditorStore((s) => s.viewScale);

  // Estimate total width (mm) based on character count
  const charCount = segments.reduce((a, s) => a + (s.text?.trim().length || 0), 0);
  const totalWidthMm = Math.round(charCount * dimensions.height * 0.6);

  // Dynamic scale bar: width in pixels = current pixels per 100 mm
  const refMm = 100;
  const pxPer100mm = Math.max(20, Math.min(viewScale.pxPer100mm || 0, 240));

  // Visual / real ratio. Assume ~3.78 CSS px per real mm on a typical screen
  // → scaleRatio = (real mm shown per 1 mm of physical screen)
  const cssPxPerMmScreen = 3.78;
  const realMmPerScreenMm = cssPxPerMmScreen / Math.max(0.0001, (viewScale.pxPerMm || 0.0001));
  const ratio = realMmPerScreenMm >= 1
    ? `1 : ${realMmPerScreenMm.toFixed(realMmPerScreenMm < 10 ? 2 : 1)}`
    : `${(1 / realMmPerScreenMm).toFixed(realMmPerScreenMm > 0.1 ? 2 : 1)} : 1`;

  return (
    <div className="scale-indicator" data-testid="scale-indicator">
      <div className="scale-info">
        <Ruler size={12} />
        <span>Échelle écran</span>
      </div>
      <div className="scale-ruler">
        <div className="scale-bar" style={{ width: `${pxPer100mm}px` }} data-testid="scale-bar-dynamic">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div key={i} className={`scale-tick ${i % 5 === 0 ? 'major' : ''}`} />
          ))}
        </div>
        <div className="scale-label">
          <span>0</span>
          <span><b>{refMm} mm</b></span>
        </div>
      </div>
      <div className="scale-ratio" data-testid="scale-ratio">
        <ZoomIn size={11} /> <b>{ratio}</b> <span className="muted">(écran : réel)</span>
      </div>
      <div className="scale-dimensions">
        <div><b>H</b> {dimensions.height} mm</div>
        <div><b>L</b> {totalWidthMm} mm</div>
        <div><b>P</b> {dimensions.depth} mm</div>
      </div>
    </div>
  );
}
